import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import CustomPagination from "../../components/pagination";
import { agentConfigService } from "../../utils/services/agentConfigService";
import AgentConfigModal from "../../components/agent-config-modal";
import AgentConfigList from "../../components/agent-config-list";
import buildQuery from "../../utils/query-builder.js";

const initialState = {
  columns: [
    {
      name: "Name",
      key: "name",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      searchKey: "",
    },
    {
      name: "Agent ID",
      key: "id",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      searchKey: "",
    },
  ],
  limit: 15,
};

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    default:
      return state;
  }
}

export default function AgentConfig() {
  const [agentData, setAgentData] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [filterData, dispatch] = useReducer(filterReducer, initialState);
  const [page, setPage] = useState(0);
  const [dataCount, setDataCount] = useState(filterData.limit);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [viewMode, setViewMode] = useState("list");

  const fetchAgentData = async () => {
    setLoading(true);
    try {
      const query = buildQuery(filterData, page);
      const response = await agentConfigService.fetch(
        searchValue,
        query,
        "name"
      );
      setAgentData(response.data);
      setDataCount(response.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentData();
  }, [page, searchValue, filterData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_zone.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "340px" }}
      />
    </div>
  );

  return (
    <DashboardContainer
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"Agent Config List"}
      title={" + Agent Config"}
      setViewMode={setViewMode}
      hideFilterClient
      filterData={filterData}
      fields={filterData.columns}
      onClickRefresh={() => fetchAgentData()}
    >
      <AgentConfigModal
        selectedAgent={selectedAgent}
        handleClose={() => {
          setOpenModal(false);
          setSelectedAgent(null);
        }}
        open={openModal}
        onAddData={fetchAgentData}
      />
      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}
      {agentData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <NoDataImage />
        </div>
      ) : (
        <AgentConfigList
          onDeleteData={() => fetchAgentData()}
          onEditData={(e) => {
            setSelectedAgent(e);
            setOpenModal(true);
          }}
          data={agentData}
          viewMode={viewMode}
          selectedAgent={selectedAgent}
          setSelectedAgent={setSelectedAgent}
          currentPage={page}
          itemsPerPage={filterData.limit}
        />
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={filterData.limit}
        page={page}
        setPage={setPage}
        setRowsPerPage={(e) =>
          dispatch({ type: "UPDATE_LIMIT", payload: e })
        }
        disableNext={dataCount <= (page + 1) * filterData.limit}
      />
    </DashboardContainer>
  );
}
